import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=635b193e&scoped=true"
import script from "./Form1.vue?vue&type=script&lang=js"
export * from "./Form1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b193e",
  null
  
)

export default component.exports